import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

export default function AdminHome() {
  const { authFetch } = useAuth();
  const [stats, setStats] = useState({ articles: 0, notes: 0, subjectsNotes: 0, cards: 0, decks: 0, qcm: 0, subjects: 0, plans: 0 });

  useEffect(() => {
    Promise.all([
      authFetch('/api/articles/admin').then(r => r.json()).catch(() => []),
      authFetch('/api/admin/notes').then(r => r.json()).catch(() => []),
      authFetch('/api/admin/cards/decks').then(r => r.json()).catch(() => []),
      authFetch('/api/admin/qcm/subjects').then(r => r.json()).catch(() => []),
      fetch('/api/plans').then(r => r.json()).catch(() => [])
    ]).then(([a, nt, t, e, pl]) => setStats({ articles: a.length, notes: nt.length, subjectsNotes: new Set(nt.map(n => n.subject_id)).size, decks: t.length, cards: t.reduce((n, d) => n + d.card_count, 0), qcm: e.reduce((n, s) => n + s.quiz_count, 0), subjects: e.length, plans: pl.length }));
    // eslint-disable-next-line
  }, []);

  return (
    <div>
      <h1 style={{ fontStyle: 'italic', fontSize: '3rem' }}>bonjour fatima ✦</h1>
      <p style={{ marginBottom: '2rem', color: 'var(--ink-soft)' }}>Gérez votre contenu depuis cet espace.</p>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: '1rem' }}>
        <div className="timeline-card">
          <h3 style={{ fontSize: '3rem', color: 'var(--terracotta)' }}>{stats.articles}</h3>
          <p>articles</p>
          <Link to="/admin/articles" className="btn secondary" style={{ marginTop: '1rem', display: 'inline-block' }}>gérer →</Link>
        </div>
        <div className="timeline-card">
          <h3 style={{ fontSize: '3rem', color: 'var(--terracotta)' }}>{stats.notes}</h3>
          <p>notes dans {stats.subjectsNotes} sujet(s)</p>
          <Link to="/admin/notes" className="btn secondary" style={{ marginTop: '1rem', display: 'inline-block' }}>gérer →</Link>
        </div>
        <div className="timeline-card">
          <h3 style={{ fontSize: '3rem', color: 'var(--olive)' }}>{stats.plans}</h3>
          <p>plans (PDF / Word)</p>
          <Link to="/admin/plans" className="btn secondary" style={{ marginTop: '1rem', display: 'inline-block' }}>gérer →</Link>
        </div>
        <div className="timeline-card">
          <h3 style={{ fontSize: '3rem', color: 'var(--olive)' }}>{stats.cards}</h3>
          <p>cartes dans {stats.decks} paquet(s)</p>
          <Link to="/admin/cards" className="btn secondary" style={{ marginTop: '1rem', display: 'inline-block' }}>gérer →</Link>
        </div>
        <div className="timeline-card">
          <h3 style={{ fontSize: '3rem', color: 'var(--sun)' }}>{stats.qcm}</h3>
          <p>QCM dans {stats.subjects} sujet(s)</p>
          <Link to="/admin/qcm" className="btn secondary" style={{ marginTop: '1rem', display: 'inline-block' }}>gérer →</Link>
        </div>
      </div>

      <div style={{ marginTop: '3rem' }}>
        <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem' }}>Pages du site</h2>
        <div style={{ display: 'flex', gap: '1rem', flexWrap: 'wrap' }}>
          <Link to="/admin/about" className="btn">✎ Éditer "À propos"</Link>
          <Link to="/admin/cv" className="btn">✎ Éditer le CV</Link>
        </div>
      </div>
    </div>
  );
}
